import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

// Action Types
export const getProductRequest = () => ({ type: 'GET_PRODUCT_REQUEST' })
export const getProductSuccess = (data) => ({ type: 'GET_PRODUCT_SUCCESS', data })
export const getProductFailure = (error) => ({ type: 'GET_PRODUCT_FAILURE', error })

export const addProductRequest = () => ({ type: 'ADD_PRODUCT_REQUEST' })
export const addProductSuccess = () => ({ type: 'ADD_PRODUCT_SUCCESS' })
export const addProductFailure = (error) => ({ type: 'ADD_PRODUCT_FAILURE', error })

export const updateProductRequest = () => ({ type: 'UPDATE_PRODUCT_REQUEST' })
export const updateProductSuccess = () => ({ type: 'UPDATE_PRODUCT_SUCCESS' })
export const updateProductFailure = (error) => ({ type: 'UPDATE_PRODUCT_FAILURE', error })

export const deleteProductRequest = () => ({ type: 'DELETE_PRODUCT_REQUEST' })
export const deleteProductSuccess = () => ({ type: 'DELETE_PRODUCT_SUCCESS' })
export const deleteProductFailure = (error) => ({ type: 'DELETE_PRODUCT_FAILURE', error })

// Fetch Products
export const getProducts = (categoryId, subcategoryId) => {
  return (dispatch) => {
    dispatch(getProductRequest())
    fetch(
      URL.BASE_URL +
        URL.END_POINT.products +
        `?categoryId=${categoryId}&subcategoryId=${subcategoryId}&page=${1}&limit=${100}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          USERID: localStorage.getItem('USERID'),
          Authorization: `Bearer token=${localStorage.getItem('token')}`,
        },
      },
    )
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getProductSuccess(data))
      })
      .catch((error) => {
        dispatch(getProductFailure(error.message))
        toast.error(error.message)
      })
  }
}

// Add Product
export const addProduct = (newProduct, body) => {
  return (dispatch) => {
    dispatch(addProductRequest())
    fetch(URL.BASE_URL + URL.END_POINT.products, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: newProduct,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(addProductSuccess())
        toast.success('Product added successfully')
        dispatch(getProducts(body.category, body.sub_category))
      })
      .catch((error) => {
        dispatch(addProductFailure(error.message))
        toast.error(error.message)
      })
  }
}

// Update Product
export const updateProduct = (updatedProduct, body) => {
  return (dispatch) => {
    dispatch(updateProductRequest())
    fetch(URL.BASE_URL + URL.END_POINT.products, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: updatedProduct,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(updateProductSuccess())
        toast.success('Product updated successfully')
        dispatch(getProducts(body.category, body.sub_category))
      })
      .catch((error) => {
        dispatch(updateProductFailure(error.message))
        toast.error(error.message)
      })
  }
}

// Delete Product
export const deleteProduct = (id, category, sub_category) => {
  return (dispatch) => {
    dispatch(deleteProductRequest())
    fetch(URL.BASE_URL + URL.END_POINT.products + '?id=' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(deleteProductSuccess())
        toast.success('Product deleted successfully')
        dispatch(getProducts(category, sub_category))
      })
      .catch((error) => {
        dispatch(deleteProductFailure(error.message))
        toast.error(error.message)
      })
  }
}

// Reducer
const initialState = {
  products: [],
  loading: false,
  error: null,
}

export const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PRODUCT_REQUEST':
    case 'ADD_PRODUCT_REQUEST':
    case 'UPDATE_PRODUCT_REQUEST':
    case 'DELETE_PRODUCT_REQUEST':
      return { ...state, loading: true, error: null }
    case 'GET_PRODUCT_SUCCESS':
      return { ...state, products: action.data.data, loading: false, error: null }
    case 'ADD_PRODUCT_SUCCESS':
    case 'UPDATE_PRODUCT_SUCCESS':
    case 'DELETE_PRODUCT_SUCCESS':
      return { ...state, loading: false, error: null }
    case 'GET_PRODUCT_FAILURE':
    case 'ADD_PRODUCT_FAILURE':
    case 'UPDATE_PRODUCT_FAILURE':
    case 'DELETE_PRODUCT_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
